import React from 'react';
export function EditorClearStyleIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2H9a1 1 0 000 2h4.635l-1.17 3.698a1 1 0 101.906.604L15.732 4H20a1 1 0 100-2zm-16.293.293a1 1 0 10-1.414 1.414l8.691 8.691-2.592 8.304a1 1 0 001.909.596l2.28-7.303 7.712 7.712a1 1 0 101.414-1.414l-18-18z"
  }));
}